import axios from "axios";
import {cbanklocal} from "../app.config"
import store from "../store/store";

const apiClient = axios.create({
  baseURL: cbanklocal,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  }
});
apiClient.interceptors.request.use(config => {
  store.getters["auth/getUserTokenFromLocalStorage"] != null ? config.headers.Authorization = store.getters["auth/getUserTokenFromLocalStorage"] : '';
  return config;
});
// https://cors-anywhere.herokuapp.com

export default {
  callUploadFtApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("/transaction/create", payload);
  },
  callSingleUploadFtApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("/transaction/raw/create", payload);
  },
  callGetBatchStatusApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("/transaction/batchref", payload);
  },
  callGetBatchTransactionApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("/transaction/transbatch", payload);
  },
  callSingleTransferInit(payload) {
    return apiClient.post("operations/transferinitiate", payload)
  },
  callAllBatches(payload) {
    return apiClient.post("transaction/getbatches", payload)
  },
  getAllBatches() {
    return apiClient.post("transaction/batch/all")
  },
  getAllUsers() {
    return apiClient.get("users/")
  },
  getAllCompanies() {
    return apiClient.get("companies/")
  },
  callPushBatchQueue(payload) {
    return apiClient.post("transaction/pushqueue", payload)
  },
  callAuthorizeTransaction(payload) {
    return apiClient.post("transaction/authorize", payload)
  },
  callDeclineTransactionBatch(payload) {
    return apiClient.post("transaction/declinebatch", payload)
  },

  callDeleteTransactionAPI(payload) {
    return apiClient.post("transaction/delete", payload)
  },
  callBankListAPI(payload) {
    return apiClient.post("transaction/banklist", payload)
  },

  callNameEnquiry(payload) {
    return apiClient.post("transaction/rubies/nameenquiry", payload)
  },
  callSingleft(payload) {
    return apiClient.post("transaction/single/create", payload)

  },
  submitSupportForm(payload){
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("users/sendsupport", payload);
  }
};
